import React from 'react';

const HTMLParser = ({ htmlContent }) => {
  const parseHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const elements = doc.body.childNodes;

    const renderElements = [];

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      renderElements.push(renderNode(element, i));
    }

    return <div className="parsed-html-content">{renderElements}</div>;
  };

  const renderNode = (node, key) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const tag = node.tagName;
      const children = [];

      for (let i = 0; i < node.childNodes.length; i++) {
        children.push(renderNode(node.childNodes[i], i));
      }

      const style = {};

      // Check for font family style
      if (node.style.fontFamily) {
        style.fontFamily = node.style.fontFamily;
      }

      // Check for text color style
      if (node.style.color) {
        style.color = node.style.color;
      }

      // Check for background color style
      if (node.style.backgroundColor) {
        style.backgroundColor = node.style.backgroundColor;
      }
      if(node.style.fontSize){
        style.fontSize = node.style.fontSize;
      }
      return React.createElement(tag, { key, style }, children);
    }

    return null;
  };

  return parseHTML(htmlContent);
}

export default HTMLParser;
